import { render, staticRenderFns } from "./appoint_interpreter.vue?vue&type=template&id=7a976808&scoped=true&"
import script from "./appoint_interpreter.vue?vue&type=script&lang=js&"
export * from "./appoint_interpreter.vue?vue&type=script&lang=js&"
import style0 from "./appoint_interpreter.vue?vue&type=style&index=0&id=7a976808&lang=less&scoped=true&"
import style1 from "./appoint_interpreter.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a976808",
  null
  
)

export default component.exports